export enum SkillCategory {
  complexReasoning = "complexReasoning",
  memory = "memory",
  executiveFunctions = "executiveFunctions",
  speed = "speed",
}

export interface Score {
  zScore: number | undefined;
  percentile: number | undefined;
}

export interface Skill {
  id: number;
  label: string;
  category: SkillCategory;
  overall: Score;
  accuracy?: Score;
  efficiency?: Score;
  speed?: Score;
  valid?: boolean | null;
}

// export interface Skills {
//   verbalReasoning: Skill | null;
//   abstractReasoning: Skill | null;
//   spatialPerception: Skill | null;
//   verbalMemory: Skill | null;
//   visualMemory: Skill | null;
//   attention: Skill | null;
//   workingMemory: Skill | null;
//   flexibleThinking: Skill | null;
//   processingSpeed: Skill | null;
//   visualMotorSpeed: Skill | null;
// }
